import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

type Props = {
  clientId: string;
};

export const useDisconnectAsset = ({ clientId }: Props) => {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending: isLoading } = useMutation<{ data: unknown }, Error, string>({
    mutationFn: (assetId: string) =>
      api.put(`clients/${clientId}/assets/${assetId}/disconnect-from-feed`, {}),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['clients', clientId] });
    },
  });

  return { disconnectAsset: mutateAsync, isLoading };
};
